module.exports = __webpack_public_path__ + "img/head_point.fa7d2ef4.png";